import { createContext } from "react"

export type User = Partial<{
  authorization_token: string
  // 农行token
  jtoken: string
  ktoken: string
  userRole: string
  user_name: string
  user_type: string
  oauth_uname: string
  expires: number | string | Date
  [propName: string]: any
}>

interface AuthContextType {
  user: User
  signin: (user: User, callback: VoidFunction) => void
  signout: (callback: VoidFunction) => void
}

export const AuthContext = createContext<AuthContextType>({} as AuthContextType)
